import React, { forwardRef, useEffect, useRef, useState } from 'react';
import hall1 from '../../images/place/ueco_hall.jpg';
// import hall2 from '../../images/place/dcc_hall2.jpg';
import { IoIosArrowUp, IoIosArrowDown } from 'react-icons/io';
import { retrieveDngrEvalDtl, retrieveWrkDclrDtl } from '../../api/FnSmartTBM';
import ReactDOMServer from 'react-dom/server';
import { Tooltip } from "react-tooltip";
const $ = require("jquery")

export const TmTBMDngrEval = forwardRef<any, any>(({ user, agrd, setAgrd, mainDtlData, fldAgntDataList, wrkrInfoDataList, dngrEvalDataList, wrkDclrList,
       wrkDclrSeq, wrkInfo, setReadWrkDclrList, setFldAgntDataList, setWrkrInfoDataList, setMainDtlData, setSelect, setSelectData, setDngrEvalDataList, setApprMemo, apprMemo }, dngrEvalRef) => {

  const inputRef = useRef<any>();
  const inputClick = () => { inputRef.current.click(); };
  const [viewInfo, setViewInfo] = useState(true);
  const [viewFldAgnt, setViewFldAgnt] = useState(true);
  const [viewRskFctr, setViewRskFctr] = useState(true);
  const [viewWrkrList, setViewWrkrList] = useState(true);
  const [viewMemo, setViewMemo] = useState(true);
  const [placeSrc, setPlaceSrc] = useState<string>();
  const mapRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    $("#team-tbm-area").on("scroll", function () {
      if (mapRef && mapRef.current) {
        var width = mapRef.current.getBoundingClientRect().width
        var height = mapRef.current.getBoundingClientRect().height
        var maxCellXCount = 30
        var maxCellYCount = 30
        var stepCellXCount = width / maxCellXCount
        var stepCellYCount = height / maxCellYCount
        var points = $("[data-ge-place-point='true']")
        $.each(points, function (index: number, elem: any) {
          var x = $(elem).data("work-plc-x")
          var y = $(elem).data("work-plc-y")
          var left = stepCellXCount * x - (stepCellXCount / 2)
          var top = stepCellYCount * y - (stepCellYCount / 2)
          $(elem).css("display", "")
          $(elem).css("left", left)
          $(elem).css("top", top)
          //alert(width + " / " + height + " / " + left + " / " + top)
        })
      }
    })
    retrieveWrkDclrDtl({ setReadWrkDclrList, wrkDclrList, setSelect, setSelectData });
    retrieveDngrEvalDtl({ wrkDclrSeq, setFldAgntDataList, setWrkrInfoDataList, setMainDtlData, setDngrEvalDataList, setApprMemo });
    setPlaceSrc(hall1)
  }, []);
  useEffect(() => {
    if (mainDtlData) {
      var exbtPlcNm = mainDtlData.exbtPlcNm
      if (exbtPlcNm.indexOf("1") > -1) {
        setPlaceSrc(hall1)
      } else {
        setPlaceSrc(hall1)
      }
    }
  }, [mainDtlData])


  return (
    <div className='flex flex-col justify-center w-[260px] sm:w-[318px] md:w-[750px]' ref={dngrEvalRef}>
      <button onClick={() => setViewInfo(!viewInfo)} className='mt-24 md:mt-[60px] flex justify-between items-center outline-none border-none w-full h-47 md:h-[117px] rounded-[5px] md:rounded-[12px] shadow-[0_0_3px_1px_rgba(0,0,0,0.10)]'>
        <div className='flex flex-col justify-center items-start pl-18 md:pl-[45px] w-[155px] sm:w-[210px] md:w-[525px] text-13 sm:text-15 md:text-37 font-preBold'>개요</div>
        {!viewInfo && <IoIosArrowDown className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
        {viewInfo && <IoIosArrowUp className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
      </button>
      {viewInfo &&
        <div className='flex mt-20 text-14 md:mt-[50px] md:text-35'>
          <div className='font-preBold'>
            <p className='ml-10 sm:ml-14 md:ml-[35px] mb-15 md:mb-[37px]'>행사명</p>
            <p className='ml-10 sm:ml-14 md:ml-[35px] mb-15 md:mb-[37px] mr-20 md:mr-[50px]'>참가업체명</p>
            <p className='ml-10 sm:ml-14 md:ml-[35px] mb-15 md:mb-[37px]'>부스 번호</p>
            <p className='ml-10 sm:ml-14 md:ml-[35px] mb-15 md:mb-[37px]'>부스 수</p>
            <p className='ml-10 sm:ml-14 md:ml-[35px] mb-15 md:mb-[37px]'>부스 형태</p>
            <p className='ml-10 sm:ml-14 md:ml-[35px] mb-15 md:mb-[37px]'>장소</p>
            <p className='ml-10 sm:ml-14 md:ml-[35px] mb-15 md:mb-[37px]'>준비기간</p>
            <p className='ml-10 sm:ml-14 md:ml-[35px]'>철거기간</p>
          </div>
          <div className='font-preLight w-[70%]'>
            <p className='mb-15 md:mb-[37px] truncate'>{mainDtlData?.evntNm}</p>
            <p className='mb-15 md:mb-[37px]'>{mainDtlData?.ptcptCmpnyNm}</p>
            <p className='mb-15 md:mb-[37px]'>{mainDtlData?.bthNos}</p>
            <p className='mb-15 md:mb-[37px]'>{mainDtlData?.bthCnt === 0 ? '-' : mainDtlData?.bthCnt}</p>
            <p className='mb-15 md:mb-[37px]'>{mainDtlData?.bthTpNm}</p>
            <p className='mb-15 md:mb-[37px]'>{mainDtlData?.exbtPlcNm}</p>
            <div className='flex items-center mb-15 md:mb-[37px]'><p>{mainDtlData?.cnstrStrtDt}</p><p className='mx-4 md:mx-[10px]'>~</p><p>{mainDtlData?.cnstrEndDt}</p></div>
            <div className='flex items-center'><p>{mainDtlData?.dmlnStrtDt}</p><p className='mx-4 md:mx-[10px]'>~</p><p>{mainDtlData?.dmlnEndDt}</p></div>
          </div>
        </div>
      }
      <button onClick={() => setViewFldAgnt(!viewFldAgnt)} className='mt-24 md:mt-[60px] flex justify-between items-center outline-none border-none w-full h-47 md:h-[117px] rounded-[5px] md:rounded-[12px] shadow-[0_0_3px_1px_rgba(0,0,0,0.10)]'>
        <div className='flex flex-col justify-center items-start pl-18 md:pl-[45px] w-[155px] sm:w-[210px] md:w-[525px] text-13 sm:text-15 md:text-37 font-preBold'>현장 대리인</div>
        {!viewFldAgnt && <IoIosArrowDown className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
        {viewFldAgnt && <IoIosArrowUp className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
      </button>
      {viewFldAgnt &&
        <table className='table-fixed w-[260px] sm:w-[318px] md:w-[750px] overflow-auto mt-24 md:mt-[60px]'>
          <tbody>
            <tr className='bg-[#F6F7F9] h-45 md:h-[112px] text-12 sm:text-13 md:text-32 leading-15 md:leading-[37px] border border-x-0 border-[#CACACA]'>
              <td className='align-middle text-center w-60 sm:w-80 md:w-[200px]'>성명</td>
              <td className='align-middle text-center w-40 sm:w-65 md:w-[162px] '>직책</td>
              <td className='align-middle text-center w-90 sm:w-110 md:w-[250px]'>휴대폰번호</td>
            </tr>
            {fldAgntDataList.map((agnt: any, idx: number) => {
              return (
                <tr key={idx} className='h-54 md:h-[135px] text-12 sm:text-14 md:text-35 leading-17 md:leading-[42px] font-preLight border border-x-0 border-t-0 border-[#CACACA]'>
                  <td className='align-middle text-center truncate'>{agnt.name}</td>
                  <td className='align-middle text-center truncate'>{agnt.position}</td>
                  <td className='align-middle text-center'>{agnt.phone}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      }
      <button onClick={() => setViewRskFctr(!viewRskFctr)} className='mt-24 md:mt-[60px] flex justify-between items-center outline-none border-none w-full h-47 md:h-[117px] rounded-[5px] md:rounded-[12px] shadow-[0_0_3px_1px_rgba(0,0,0,0.10)]'>
        <div className='flex flex-col justify-center items-start pl-18 md:pl-[45px] w-[155px] sm:w-[210px] md:w-[525px] text-13 sm:text-15 md:text-37 font-preBold'>위험요인 확인</div>
        {!viewRskFctr && <IoIosArrowDown className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
        {viewRskFctr && <IoIosArrowUp className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
      </button>
      {viewRskFctr && <>
        {dngrEvalDataList.length > 0 ? dngrEvalDataList.map((data: any) => {
          return (
            <table key={data.seq} className='table-fixed w-full overflow-auto mt-24 md:mt-[60px]'>
              <tbody>
                <tr className='h-36 md:h-[90px] border border-x-0 border-[#CACACA]'>
                  <td colSpan={3} className='bg-[#F6F6F8] align-middle text-center text-13 leading-15 md:text-[32px] md:leading-[37px]'>세부작업</td>
                  <td colSpan={13} className='pl-10 md:pl-[25px] font-preLight text-14 leading-16 md:text-[35px] md:leading-[40px]'>{data.dtlWrk}</td>
                </tr>
                <tr className='h-36 md:h-[90px] border border-x-0 border-[#CACACA]'>
                  <td colSpan={3} className='bg-[#F6F6F8] align-middle text-center text-13 leading-15 md:text-[32px] md:leading-[37px]'>위험요인</td>
                  <td colSpan={13} className='pl-10 md:pl-[25px] font-preLight text-14 leading-16 md:text-[35px] md:leading-[40px]'>{data.dngrRsn}</td>
                </tr>
                <tr className='h-36 md:h-[90px] text-14 leading-16 md:text-[35px] md:leading-[40px] border border-x-0 border-t-0 border-[#CACACA]'>
                  <td colSpan={3} className='bg-[#F6F6F8] align-middle text-center text-13 leading-15 md:text-[32px] md:leading-[37px]'>빈도</td>
                  <td colSpan={2} className='text-center font-preLight text-14 leading-16 md:text-[35px] md:leading-[40px]'>{data.dngrFrqncy}</td>
                  <td colSpan={3} className='bg-[#F6F6F8] align-middle text-center text-13 leading-15 md:text-[32px] md:leading-[37px]'>강도</td>
                  <td colSpan={2} className='text-center font-preLight text-14 leading-16 md:text-[35px] md:leading-[40px]'>{data.dngrIntnsty}</td>
                  <td colSpan={3} className='bg-[#F6F6F8] align-middle text-center text-13 leading-15 md:text-[32px] md:leading-[37px]'>위험도</td>
                  <td colSpan={3}
                    className={data.dngrScor == 9 ? 'bg-[#FFEEEF] text-[#EA505E] text-center font-preLight text-14 leading-16 md:text-[35px] md:leading-[40px]'
                      : data.dngrScor >= 6 && data.dngrScor >= 4 ? 'text-[#FFB237] bg-[#FFFAE0] text-center font-preLight text-14 leading-16 md:text-[35px] md:leading-[40px]'
                        : 'text-[#5DB202] bg-[#F4FBE9] text-center font-preLight text-14 leading-16 md:text-[35px] md:leading-[40px]'}>
                    {data.dngrScor}{data.dngrScor == 9 ? '(높음)' : data.dngrScor <= 6 && data.dngrScor >= 4 ? '(보통)' : '(낮음)'}
                  </td>
                </tr>
                <tr className='h-36 md:h-[90px] border border-x-0 border-[#CACACA]'>
                  <td colSpan={3} className='bg-[#F6F6F8] align-middle text-center text-13 leading-15 md:text-[32px] md:leading-[37px]'>감소대책</td>
                  <td colSpan={13} className='pl-10 font-preLight text-14 leading-16 md:text-[35px] md:leading-[40px]'>이동통로 정리정돈 및 이상유무 확인 후 이동</td>
                </tr>
              </tbody>
            </table>
          )
        }) : <p className={`mt-15 ml-15 text-15 leading-18 md:mt-[37px] md:ml-[37px] md:text-37 md:leading-[45px] font-normal truncate`}>등록된 위험요인이 없습니다.</p>

        }

        {dngrEvalDataList.length > 0 &&
          <table className='table-fixed w-[265px] sm:w-[318px] md:w-[750px] overflow-auto mt-24 md:mt-[60px]'>
            <tbody>
              <tr className='bg-[#F6F7F9] h-36 md:h-[90px] text-12 sm:text-13 md:text-32 leading-15 md:leading-[37px] border border-x-0 border-[#CACACA]'>
                <td className='align-middle text-center'>작업장소</td>
              </tr>
              <tr className='border border-x-0 border-t-0 border-[#CACACA]'>
                <td className='algin-middle text-center relative'>
                  <img ref={mapRef} className='object-cover' src={placeSrc} alt='map' />
                  {dngrEvalDataList.map((data: any, i1: number) => {
                    if (data.workPlc) {
                      var arr = eval(data.workPlc)
                      return <React.Fragment key={i1}>
                        {arr.map((point: any, i2: number) =>
                          <div key={i2}
                            data-tooltip-id="tooltip"
                            data-tooltip-content={data.dtlWrk + '(위험도:' + (data.dngrScor === 9 ? '높음' : data.dngrScor <= 6 && data.dngrScor >= 4 ? '보통' : '낮음') + ')'}
                            className='ge-mark-01' data-work-plc-x={point[0]} data-work-plc-y={point[1]} data-ge-place-point="true" style={{ display: "none" }} />
                        )}
                        <Tooltip id="tooltip" />
                      </React.Fragment>
                    }
                  })}
                </td>
              </tr>
            </tbody>
          </table>}
      </>}
      <button
        onClick={() => setViewWrkrList(!viewWrkrList)}
        className='mt-24 md:mt-[60px] flex justify-between items-center outline-none border-none w-full h-47 md:h-[117px] rounded-[5px] md:rounded-[12px] shadow-[0_0_3px_1px_rgba(0,0,0,0.10)]'>
        <div className='flex flex-col justify-center items-start pl-18 md:pl-[45px] w-[155px] sm:w-[210px] md:w-[525px] text-13 sm:text-15 md:text-37 font-preBold'>작업자 명단</div>
        {!viewWrkrList && <IoIosArrowDown className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
        {viewWrkrList && <IoIosArrowUp className='mmr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
      </button>
      {viewWrkrList &&
        <table className='table-fixed w-[265px] sm:w-[318px] md:w-[750px] overflow-auto mt-24 md:mt-[60px]'>
          <tbody>
            <tr className='bg-[#F6F7F9] h-45 md:h-[112px] text-12 sm:text-13 md:text-32 leading-15 md:leading-[37px] border border-x-0 border-[#CACACA]'>
              <td className='align-middle text-center w-30 sm:w-50 md:w-[125px]'>상태</td>
              <td className='align-middle text-center w-70 sm:w-95 md:w-[237px]'>성명</td>
              <td className='align-middle text-center w-90 sm:w-115 md:w-[287px]'>휴대폰번호</td>
            </tr>
            {wrkrInfoDataList.map((wrkr: any, idx: number) => {
              return (
                <tr key={idx} className='h-54 md:h-[135px] text-12 sm:text-13 md:text-32 leading-17 md:leading-[42px] font-preLight border border-x-0 border-t-0 border-[#CACACA]'>
                  <td className={wrkr.isAbsent ? 'align-middle text-center text-[#EA505E]'
                    : wrkr.tbmPrcsStat == '003' ? 'align-middle text-center text-[#5DB202]'
                      : 'align-middle text-center text-[#EA505E]'}  >{wrkr.isAbsent ? '결근' : wrkr.tbmPrcsStat == '003' ? '출근' : '결근'}</td>
                  <td className='align-middle text-center truncate'>{wrkr.name}</td>
                  <td className='align-middle text-center'>{wrkr.phone}</td>
                </tr>
              );
            })}

            <tr className='h-54 md:h-[135px] text-12 sm:text-13 md:text-32 leading-17 md:leading-[42px] font-preLight border border-x-0 border-t-0 border-[#CACACA]'>

              <td colSpan={3} className='align-middle text-center'>
                <span className={'mr-15 md:mr-[37px]'}>{'총원: ' + wrkrInfoDataList.length + '명'}</span>
                <span className={'text-[#5DB202] mr-15 md:mr-[37px]'}>{'출근: ' + wrkrInfoDataList.filter((data: any) => data.isAbsent == false).length + '명'}</span>
                <span className={'text-[#EA505E]'}>{'결근: ' + wrkrInfoDataList.filter((data: any) => data.isAbsent == true).length + '명'}</span>
              </td>
            </tr>
          </tbody>
        </table>
      }
      <button onClick={() => setViewMemo(!viewMemo)} className='mt-24 md:mt-[60px] flex justify-between items-center outline-none border-none w-full h-47 md:h-[117px] rounded-[5px] md:rounded-[12px] shadow-[0_0_3px_1px_rgba(0,0,0,0.10)]'>
        <div className='flex flex-col justify-center items-start pl-18 md:pl-[45px] w-[155px] sm:w-[210px] md:w-[525px] text-13 sm:text-15 md:text-37 font-preBold'>메모</div>
        {!viewMemo && <IoIosArrowDown className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
        {viewMemo && <IoIosArrowUp className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
      </button>
      {viewMemo &&
        <div className='mt-23 md:mt-[57px] bg-[#F6F6F8] w-full h-100 md:h-[250px] overflow-auto scrollbar-hide px-9 py-9 md:px-[22px] md:py-[22px] text-14 leading-16 md:text-[35px] md:leading-[40px] rounded-[5px] md:rounded-[12px]'>{apprMemo}</div>
      }
      {/*<div className='flex w-full mt-11 md:mt-[27px]'>*/}
      {/*  {!agrd[1] ? <input ref={inputRef} onChange={() => setAgrd((prevState: any) => ({ ...prevState, 1: !agrd[1] }))} type='checkbox' className='accent-point md:w-[40px]' />*/}
      {/*    : <input ref={inputRef} onChange={() => setAgrd((prevState: any) => ({ ...prevState, 1: !agrd[1] }))} type='checkbox' className='accent-point md:w-[40px]' defaultChecked />}*/}
      {/*  <p onClick={inputClick} className='ml-10 md:ml-[25px] text-[#9C9C9B] text-13 leading-15 md:text-[32px] md:leading-[37px] font-preLight underline underline-offset-1 decoration-[#9C9C9B] decoration-[0.5px]'>모든 위험요인을 공지하고 작업자 명단을 확인했습니다.</p>*/}
      {/*</div>*/}
    </div>
  );
});
